export type InputType = 'password' | 'email' | 'hidden' | 'number' | 'text' | 'postalCodeAndCity' | 'multipleSelect' | 'checkbox';
export type InputMode = 'url' | 'email' | 'text' | 'decimal' | 'search' | 'none' | 'tel' | 'numeric' | undefined;
export enum ValidationType {
    Error,
    Warning
}

export interface ValidationIssue {
    message: string;
    type: ValidationType;
}

export type FormDataTypes = string | string[] | number | boolean;

export interface FormField {
    displayName: string;
    type?: InputType;
    // eslint-disable-next-line
    value?: any;
    wasActive?: boolean;
    inputmode?: InputMode;
    validationIssues?: ValidationIssue[];
    warnings?: string[];
    isCollapsed?: boolean;
    collapseText?: string;
    validation?: {
        required?: {
            value: boolean;
            message?: string;
            type?: ValidationType;
        };
        regEx?: {
            value: RegExp;
            message: string;
            type?: ValidationType;
        }[];
        sameValueAs?: {
            value: string;
            message?: string;
            type?: ValidationType;
        };
        minLength?: {
            value: number;
            message?: string;
            type?: ValidationType;
        };
        maxLength?: {
            value: number;
            message?: string;
            type?: ValidationType;
        };
        email?: {
            message?: string;
            type?: ValidationType;
        };
    };
    disableWhen?: {
        hasValue?: {
            value: string;
        };
    };
    disabled?: boolean;
    autocomplete?: string;
}

export interface PostalCodeAndCityFormField extends FormField {
    city: string;
    postalCode: string;
}

export interface FormFieldValidationIssues {
    [key: string]: ValidationIssue[];
}

export interface FormFields {
    [key: string]: FormField;
}

export interface FormSubmitData {
    [key: string]: FormDataTypes;
}

export interface FormSubmitStatus {
    isSuccess: boolean;
    validationErrors?: {
        key: string;
        message: string;
    }[];
}
